import React from 'react';
import HtmlContentViewer from '../components/HtmlContentViewer';
import styled from 'styled-components';

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 2rem 1rem;
`;

const VeloInauguracionPage = () => {
  return (
    <PageContainer>
      <HtmlContentViewer 
        filePath="publicaciones/enlaweb/velo-inauguracion.htm"
        title="Discurso de Inauguración - Jornadas sobre el Velo"
      />
    </PageContainer>
  );
};

export default VeloInauguracionPage; 